module.exports = "/img/22.eb711b.webp";